var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),(_vm.$route.path != '/')?[(_vm.message)?_c('TopMsg',{attrs:{"msg":_vm.message}}):_vm._e(),(_vm.error401?.code)?_c('ErrHint',{attrs:{"error401":_vm.error401}}):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }